import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Inventario',
    path: '/inventario/devolucion',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const DevolucionPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Devolución</PageTitle>
      <View />
    </>
  );
};

export { DevolucionPage };
